/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const StickyNoteAddLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M4 1v3H1v2h3v3h2V6h3V4H6V1zM3 20v-9h2v8h8v-5a1 1 0 0 1 1-1h5V5h-8V3h9a1 1 0 0 1 1 1v11l-6 6H4a1 1 0 0 1-1-1m15.17-5H15v3.17z" />
  </Icon>
);
